import { render } from "./HelloButton.vue?vue&type=template&id=43e71af0&scoped=true"
import script from "./HelloButton.vue?vue&type=script&lang=js"
export * from "./HelloButton.vue?vue&type=script&lang=js"

import "./HelloButton.vue?vue&type=style&index=0&id=43e71af0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e71af0"]])

export default __exports__